angular.module('satv.playlist.pitch')

.factory('PitchModal', ['config', 'Modal', function(config, Modal) {
    return {
        open: function(params, data) {
            Modal.create(
                config.templateRoot + '/templates/playlists/modals/pitch',
                params,
                data
            );
        }
    };
}])

;



// WEBPACK FOOTER //
// ./vendor/sonyatv/playlistpitchclientbundle/Resources/js/angular/services/PitchModal.js